import { useEffect } from 'react';
import useRefState from 'components/hooks/useRefState';

export default function useElementDidResize(ref, cb) {
  const [, setLastSize, lastSizeRef] = useRefState({});
  useEffect(() => {
    if (!ref.current) {
      return undefined;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      if (!entries.length || !ref.current) {
        return;
      }
      const { width, height } = entries[0].contentRect;
      if (lastSizeRef.current.width !== width || lastSizeRef.current.height !== height) {
        cb({ width, height }, entries[0].target);
        setLastSize({ width, height });
      }
    });

    resizeObserver.observe(ref.current);
    return () => resizeObserver && resizeObserver.disconnect();
  }, []);
}
